<mat-card appearance="outlined" style="padding: 30px;">
    <mat-card-title>{{data.title}}</mat-card-title>
    <mat-card-content class="content">{{data.message}}</mat-card-content>
    <div mat-dialog-actions align="end">
        <button mat-button (click)="onDismiss()">{{data.noButton}}</button>&nbsp;
        <button mat-raised-button color="primary" (click)="onConfirm()">{{data.yesButton}}</button>
    </div>
</mat-card>